__turbopack_context__.v({
  "bottom": "zLzp0q_bottom",
  "buttonLabel": "zLzp0q_buttonLabel",
  "isSubmitting": "zLzp0q_isSubmitting",
  "spinner": "zLzp0q_spinner",
  "submitButton": "zLzp0q_submitButton",
});
